import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {IAddress} from "../interfaces";
import * as _ from "lodash";

@Component({
    selector: 'nc-auto-complete',
    template: `
        <div class="form-group">
            <mat-form-field class="example-full-width">
                <mat-label translate>addresses.quick_select</mat-label>
                <input type="text"
                       placeholder="{{'addresses.pick_one' | translate}}"
                       matInput
                       [formControl]="control"
                       [matAutocomplete]="auto"
                       (click)="handleClick()">
                <mat-spinner *ngIf="loading" matSuffix [diameter]="18" ></mat-spinner>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
                    <mat-option *ngFor="let option of filteredOptions" [value]="option">
                        {{ getDisplayName(option) }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>`,
})
export class NcAutoComplete implements OnInit {

    @Input()
    control: FormControl;

    @Input()
    options: IAddress[];

    @Input()
    loading;

    filteredOptions: IAddress[];

    ngOnInit() {
        this.control.valueChanges.pipe(
            startWith(''),
            map(value => {
                if (_.isObject(value)){
                    this.filteredOptions = this._filter(value.company || '');
                }
                else {
                    this.filteredOptions = this._filter(value || '');
                }
            })
        ).subscribe();
    }

    handleClick() {
        this.filteredOptions = this._filter(this.control.value);
    }

    displayFn(address: IAddress): string {
        return address && address.company ? this.getDisplayName(address) : '';
    }

    getDisplayName(address): string {
        return address.company + ', ' + address.city;
    }

    private _filter(value: string) : IAddress[] {
        const filterValue = value.toLowerCase();

        if (!this.options) {
           return [];
        }

        return this.options.filter(option => this.getDisplayName(option).toLowerCase().includes(filterValue));
    }
}
